var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-location",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.995,
    height: 28.316,
    viewBox: "0 0 19.995 28.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2313",
    "data-name": "Ret\\xE2ngulo 2313",
    width: 19.995,
    height: 28.316,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4346",
    "data-name": "Grupo 4346",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2352",
    "data-name": "Caminho 2352",
    d: "M5.369,19.382c-.672-.747-1.291-1.456-1.933-2.143a12.96,12.96,0,0,1-2.243-3.01,9.836,9.836,0,1,1,18.5-6.03,9.584,9.584,0,0,1-2.4,8.243c-.764.87-1.554,1.719-2.33,2.579-.1.108-.185.225-.27.329a21.735,21.735,0,0,1,2.088.725A8.856,8.856,0,0,1,18.693,21.2c1.789,1.461,1.719,3.487-.119,4.895a9.37,9.37,0,0,1-3.518,1.582,20.153,20.153,0,0,1-11.01-.263A7.78,7.78,0,0,1,1.134,25.86,2.819,2.819,0,0,1,.241,22.5a4.141,4.141,0,0,1,1.626-1.739,10.53,10.53,0,0,1,3.144-1.286l.358-.094M9.993,22.1l.2-.24c1.852-2.238,3.648-4.522,5.641-6.645A7.626,7.626,0,0,0,17.9,9.128,7.944,7.944,0,1,0,4.172,15.26c1.4,1.549,2.744,3.155,4.1,4.743.579.677,1.131,1.377,1.718,2.094m-.008,4.37c.908-.075,1.821-.119,2.725-.233a11.115,11.115,0,0,0,3.9-1.131,5.491,5.491,0,0,0,1.234-.93.764.764,0,0,0,.008-1.16,3.969,3.969,0,0,0-.851-.713,10.493,10.493,0,0,0-3.363-1.192.51.51,0,0,0-.587.226c-.73.912-1.476,1.81-2.215,2.714a.974.974,0,0,1-1.691,0c-.757-.928-1.518-1.852-2.271-2.783a.368.368,0,0,0-.442-.166c-.566.158-1.146.264-1.707.435A6.214,6.214,0,0,0,2.435,22.69c-.721.619-.724,1.162-.016,1.79a5.6,5.6,0,0,0,1.787,1,17.752,17.752,0,0,0,5.779.988",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2353",
    "data-name": "Caminho 2353",
    d: "M73.64,66.792a4.984,4.984,0,1,1-5.022-4.976,4.982,4.982,0,0,1,5.022,4.976m-4.991,3.1a3.1,3.1,0,1,0-3.091-3.124,3.092,3.092,0,0,0,3.091,3.124",
    transform: "translate(-58.661 -56.95)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.8ad7998681abfd1ae734678f4466be63.svg";
export { ForwardRef as ReactComponent };